import { Identity } from '@/containers/Identities/types';

/**
 * Get identity name from identity ID using the available identities array
 */
export const getIdentityNameById = (
  identityId: string,
  identities: Identity[] | null
): string => {
  if (!identities || !identityId) {
    return 'Unknown Identity';
  }

  const identity = identities.find((identity) => identity.identity_id === identityId);
  return identity?.identity_name || 'Unknown Identity';
};
